export default {
    pt: {
        global: {
            ask: 'pedir',
            name: 'nome',
            email: 'E-mail',
            password: 'Palavra-passe',
            confirmPassword: 'Confirmação palavra-passe',
            entry: 'entrar',
            confirm: 'confirmar',
            profile: 'perfil',
            campaigns: 'campanhas',
            campaign: 'campanha',
            reporting: 'reporting',
            multiUsers: 'utilizador(es)',
            users: 'utilizadores',
            user: 'utilizador',
            clients: 'clientes',
            client: 'cliente',
            audit: 'auditoria',
            contact: 'contacto',
            contacts: 'contactos',
            address: 'morada',
            preferenceContact: 'data preferencial de contacto',
            receptionDate: 'receção',
            callcenterReceptionDate: 'envio',
            nif: 'NIF',
            taxpayerIdentificationNumber: 'NIF',
            nationalIdentificationNumber: 'CC',
            role: 'perfil',
            state: 'estado',
            beginDate: 'data ínicio',
            endDate: 'data fim',
            code: 'código',
            of: 'de',
            details: 'detalhes',
            requestDetails: 'detalhes do pedido',
            personContactDetails: 'detalhes do contacto',
            associations: 'associações',
            holder: 'titular',
            birthdate: 'data de nascimento',
            requestOptionalDetails: 'detalhes opcionais do pedido',
            observations: 'observações',
            requestObservations: 'observações do pedido',
            internalObservations: 'observações internas',
            callHistory: 'histórico de chamadas',
            id: 'ID',
            uiid: 'UIID',
            date: 'data',
            operator: 'operador',
            audio: 'audio',
            calls: 'chamadas',
            progress: 'progresso',
            independentCaller: 'independente',
            newCampaign: 'nova campanha',
            newClient: 'novo cliente',
            newUser: 'novo utilizador',
            newScript: 'novo guião',
            newMailTemplate: 'novo template de e-mail',
            submit: 'submeter',
            cancel: 'cancelar',
            noResults: 'Sem resultados',
            loading: 'A pedir informação',
            viewProfile: 'ver perfil',
            viewCampaign: 'ver campanha',
            viewMore: 'ver mais',
            create: 'criar',
            tokens: 'tokens',
            noAssociations: 'Não existem {type} associados(as).',
            noRecordsFound: 'Não foram encontrados registos de {type}.',
            website: 'website',
            mobile: 'telemóvel',
            phone: 'telefone',
            responsible: 'responsável',
            coppied: 'Copiado',
            clickToCopy: 'Clique para copiar.',
            search: 'Pesquisa',
            clear: 'limpar',
            generateToken: 'gerar token',
            createdAt: 'data de criação',
            expiresAt: 'data de expiração',
            exitEditMode: 'Saia do modo de edição',
            tokenInfo: 'Este token só será revalado uma única vez. Guarde-o ao carregar no token.',
            deleteToken: 'Remover token?',
            deleteAttachment: 'Remover anexo?',
            disableToken: 'Desabilitar token?',
            activeToken: 'Activar token?',
            delete: 'apagar',
            disable: 'desabilitar',
            active: 'activar',
            close: 'fechar',
            successDeleteToken: 'Token removido com sucesso.',
            successDisableToken: 'Token desabilitado com sucesso.',
            successActiveToken: 'Token activado com sucesso.',
            regist: 'registar',
            connect: 'conectar',
            gettingContactRequest: 'A obter pedido de contacto...',
            initiatingCall: 'A iniciar chamada...',
            callEvaluation: 'avaliação da chamada',
            confirmEvaluation: 'confirmar avaliação',
            selectACause: 'selecione uma causa',
            cause: 'causa',
            nextCallOn: 'Próxima chamada em',
            resume: 'retomar',
            pause: 'pausa',
            newRequest: 'Será feito um novo pedido dentro de 5 segundos.',
            index: 'home',
            rescheduleTo: 're-agendar',
            setTheTime: 'defina a hora',
            leave: 'sair',
            areYouSureYouWantToLeave: 'tem a certeza que deseja sair?',
            notFound: '404',
            seeDetails: 'Ver detalhes',
            contactPerson: 'pessoa de contacto',
            type: 'tipo',
            workflow: 'fluxo',
            add: 'Adicionar',
            addContact: 'Adicionar contacto',
            addScript: 'Adicionar guião',
            addSchedule: 'Adicionar horário',
            addMailTemplate: 'Adicionar template de e-mail',
            changePassword: 'Alterar palavra passe',
            deleteUser: 'Apagar utilizador',
            back: 'voltar',
            script: 'Guião',
            scripts: 'Guiões',
            scriptName: 'Nome do guião',
            title: 'título',
            writeYourQuestionHere: 'Escreva aqui a sua questão',
            selectQuestionType: 'Seleciona o tipo de pergunta',
            questionType: 'tipo de pergunta',
            possibleAnswer: 'Possível resposta',
            backToOperate: 'Voltar a operar',
            yes: 'Sim',
            no: 'Não',
            newContact: 'novo contacto',
            updateContact: 'atualizar contacto',
            theCallEnded: 'A chamada terminou',
            fiveSecondLeftToEnd: 'Faltam 5 segundos para terminar {type}',
            thePause: 'a pausa.',
            filligOutTheScript: 'o preenchimento do guião.',
            afterTyping: 'Após tipificação',
            duplicateContactCall: 'Tipificar contacto',
            enabled: 'activo',
            activeScript: 'Activar guião?',
            deleteScript: 'Apagar guião?',
            deleteCallState: 'Apagar estado de chamada?',
            addOptionWithNumber: 'Adicionar opção {number}',
            optionWithNumber: 'opção {number}',
            nextQuestion: 'Próxima pergunta',
            question: 'pergunta',
            callsInProgress: 'chamadas em curso',
            recipient: 'destinatário',
            dailyReporting: 'reporting diário',
            duplicate: 'duplicar',
            duplicateScript: 'Duplicar Guião',
            previewScript: 'Pré-visualizar Guião',
            monthlyReporting: 'reporting mensal',
            export: 'exportar',
            exportType: 'Exportar {type}',
            month: 'mês',
            year: 'ano',
            manualCall: 'Ligação Manual',
            areYouSureYouWantToCall: 'Tem a certeza que pretende efetuar a ligação para ',
            areYouSureYouWantTo: 'Tem a certeza que pretende ',
            record: 'Gravar',
            stopRecording: ' Parar gravação',
            openDialer: 'Abrir dialer',
            putOnHold: 'Colocar em espera',
            leaveOnHold: 'Sair do modo em espera',
            hangUpCall: 'Desligar chamada',
            schedule: 'Horário de funcionamento',
            Mon: 'Seg',
            Tue: 'Ter',
            Wed: 'Qua',
            Thu: 'Qui',
            Fri: 'Sex',
            Sat: 'Sáb',
            Sun: 'Dom',
            startsAt: 'Início',
            endsAt: 'Fim',
            day: 'dia',
            editSchedule: 'Editar horário',
            remove: 'Remover',
            continue: 'continuar',
            editConfirmation: 'Confirmação da edição',
            importContacts: 'Importar contactos',
            importFile: 'Importar ficheiro',
            importAudio: 'Importar áudio',
            EAC: 'CAE',
            zone: 'Zona',
            zipCode: 'Código postal',
            entities: 'entidades',
            previewOfScript: 'Pré-visualização do Guião',
            associateRecording: 'Associar gravação',
            call: 'chamada',
            recordingToAssociate: 'Gravação a associar',
            confirmAssociation: 'confirmar associação',
            callRules: 'regras da chamada',
            notificationEmails: 'Emails a serem notificados',
            sendEmail: 'enviar e-mail',
            mailTemplate: 'template de e-mail',
            mailTemplates: 'templates de e-mail',
            templateName: 'Nome do template',
            templates: 'templates',
            subject: 'assunto',
            emailSubject: 'Assunto do e-mail',
            selectEntities: 'selecionar entidades',
            selectRecording: 'selecionar gravação',
            howDoYouWantToImportContacts: 'Como pretende importar os contactos?',
            howDoYouWantToAssociateRecording: 'Como pretende associar a gravação?',
            attachments: 'anexos',
            attachFile: 'anexar ficheiro',
            loadingData: 'Os dados estão a ser carregados...',
            seeTotals: 'ver totais',
            additionalAnswer: 'resposta adicional',
            transfer: 'transferir',
            ddi: 'ddi',
            automaticForward: 'avanço automático (segs)',
            fieldName: 'nome do campo',
            value: 'valor',
            limitNumberOfAttempts: 'nº limite tentativas',
            intervalOfAttempts: 'intervalo de tentativas (minutos)',
            price: 'preço',
            notify: 'notificar',
            rules: 'regras',
            freeswitchExtension: 'Extensão',
            sharingRules: 'partilha de regras',
            addCallState: 'adicionar estado de chamada',
            addState: 'adicionar estado',
            callPrice: 'preço da chamada',
            group: 'grupo'
        },
        roles: {
            maintainer: 'Manutenção',
            admin: 'Administrador',
            supervisor: 'Supervisor',
            operator: 'Operador',
            auditor: 'Auditor',
            administrativeAuditor: 'Auditor Avançado'
        },
        authentication: {
            login: 'login',
            forgotPassword: 'esqueci-me da palavra-passe',
            forgot: 'recuperação de conta',
            reset: 'definição de palavra-passe',
            logout: 'logout',
            back: 'voltar ao ínicio'
        },
        states: {
            enabled: 'activo',
            standby: 'parado',
            inactive: 'inactivo',
            closed: 'fechado',
            desactivated: 'desactivado',
            received: 'recebido',
            pending: 'pendente',
            delivered: 'entregue'
        },
        error: {
            request: 'Ocorreu um problema. Verifica os seus dados e tente novamente.',
            required: 'campo obrigatório.',
            email: 'e-mail inválido.',
            price: 'preço inválido.',
            nif: 'NIF inválido.',
            password: 'palavra-passe não cumpre os requisitos.',
            confirmPassword: 'A confirmação da password deve ser igual à nova password.',
            authentication: 'Credenciais incorrectas, por favor verifique os seus dados e tente novamente.',
            isAfter: 'A data tem que ser depois da {date}.',
            validateWebsite: 'O website tem que ser um endereço válido. Ex: https://gocc.pt',
            regist: 'Sem permissões para aceder',
            connect: 'Ocorreu um erro ao connectar.',
            notFound: 'página não encontrada',
            duplicateScript: 'Não foi possível duplicar este guião. Por favor, tente mais tarde.',
            requestCall: 'Não foram encontradas chamadas por realizar',
            onlyDigits: 'O campo deve conter apenas algarismos.',
            invalidFormat: 'formato inválido',
            download: 'Ocorreu um erro no descarregamento.',
            integer: 'Apenas algarismos são permitidos',
            intervalOfAttempts: 'intervalo de tentativas inválido'
        },
        warning: {
            deleteToken: 'Ao remover este token irá perder a ligação com gocc permanentemente.',
            disableToken: 'Ao desabilitar este token irá perder a ligação com gocc temporariamente.',
            activeToken: 'Ao activar este token irá voltar a ter ligação com gocc.',
            changePassword: 'Ao fazer este pedido, o utilizador irá receber um e-mail com um endereço para alterar a palavra-passe.',
            deleteUser: 'Tem a certeza que pretende apagar este utilizador?',
            notAvailable: 'Não disponibilizado',
            activeScript: 'Ao activar este guião irá desabilitar o actual.',
            deleteScript: 'Ao apagar este guião deixará de ter acesso ao mesmo.',
            deleteCallState: 'Ao apagar este estado de chamada deixará de ter acesso ao mesmo.',
            forceEditScript: 'Existem chamadas associadas a este guião e a sua edição pode causar problemas de visualização no seu histórico.',
            callHasAssociatedAudio: 'Esta chamada tem um áudio associado, a associação vai substituir o áudio original.',
            deleteThisFile: 'remover este ficheiro',
            cantShowDataForThisSearch: 'Não foi possível mostrar dados para esta pesquisa.'
        },
        placeholders: {
            observations: 'Escreva aqui as suas observações.',
            select: 'Selecione pelo menos 1 das opções.',
            no: 'Não',
            intervalOfAttempts: 'ex: 30, 120, 240',
            price: 'ex: 0.5',
            pressSpaceToAddToTheList: 'pressione ESPAÇO para adicionar à lista'
        },
        contacts: {
            phone: 'Contacto telemóvel',
            email: 'Contacto email',
            telephone: 'Contacto telefone',
            fax: 'Contacto fax'
        },
        inputTypes: {
            string: 'Resposta curta',
            text: 'Resposta longa',
            radiobutton: 'Escolha múltipla',
            dropdown: 'Dropdown',
            datetime: 'Data & hora',
            date: 'Data',
            noReply: 'Sem resposta',
            checkbox: 'Múltipla seleção'
        },
        scriptTypes: {
            chained: 'Encadeado',
            sequence: 'Sequencial'
        },
        callGroups: {
            successfull: 'Chamada de sucesso',
            unsuccessful: 'Chamada de insucesso',
            rescheduling: 'Re-agendamento'
        },
        accessibility: {
            audioPlayer: 'Leitor de áudio',
            pause: 'Pausa',
            play: 'Tocar',
            loading: 'Carregando',
            download: 'descarregar',
            audioBar: 'Barra de áudio',
            information: 'Ícone de informação',
            alert: 'Ícone de alerta',
            arrow: 'Ícone de seta',
            audit: 'Ícone de auditoria',
            campaign: 'Ícone de campanha',
            user: 'Ícone de utilizador',
            client: 'Ícone de cliente',
            reporting: 'Ícone de reporting',
            pagination: 'Paginação',
            goTo: 'Vai para a página {page}',
            add: 'adicionar',
            addProp: 'adicionar {prop}',
            deleteProp: 'apagar {prop}',
            close: 'fechar',
            delete: 'apagar',
            active: 'activar',
            disable: 'desabilitar',
            email: 'email',
            phone: 'telefone',
            mobile: 'telemóvel',
            lup: 'lupa',
            hangUp: 'desligar',
            positive: 'positivo',
            negative: 'negativo',
            operate: 'operar',
            supervise: 'supervisionar',
            reschedule: 're-agendar',
            settings: 'configurações',
            success: 'sucesso',
            error: 'erro',
            page: 'página',
            question: 'questão',
            timer: 'contador',
            dialer: 'teclado',
            done: 'feito',
            toListen: 'escutar',
            transferCall: 'transferir chamada',
            field: 'campo',
            moveUp: 'mover para cima',
            moveDown: 'mover para baixo'
        },
        reporting: {
            totalsByTypification: 'totais por tipificação',
            finalTypificationsByHour: 'tipificações finais por hora'
        }
    }
};